// Dependencies
import styled, { css } from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

// Types
type ContainerStyleProps = {
  backgroundImage: string
}

export const Container = styled.div<ContainerStyleProps>`
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-size: auto;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;

  ${MediaQueries.amedium} {
    background-size: cover;
    padding: 32px 0 264px;
  }
`

export const Content = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 24px;

  .pdg-hero-item {
    display: none;

    ${MediaQueries.amedium} {
      display: flex;
    }
  }

  .pdg-hero-item:first-child {
    bottom: 35px;
  }

  ${MediaQueries.medium} {
    align-items: center;
  }
`

export const TextContainer = styled.div`
  width: 100%;
  max-width: 425px;
  height: 100%;
  padding: 0 32px 32px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;

  ${MediaQueries.medium} {
    padding: 0 40px 40px;
  }

  ${MediaQueries.amedium} {
    max-width: 600px;
  }
`

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const TitleSecondary = styled.p`
  color: #fdf4f5;
  text-align: center;
  font-family: 'Source Sans 3';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.96px;

  ${MediaQueries.medium} {
    font-size: 32px;
    line-height: 32px;
    letter-spacing: 3.2px;
  }
`

export const TitlePrimary = styled.p`
  color: #fdf4f5;
  font-family: 'Source Sans 3';
  font-size: 64px;
  font-style: normal;
  font-weight: 400;
  line-height: 72px;

  > strong {
    font-weight: 900;
  }

  ${MediaQueries.medium} {
    font-size: 72px;
    line-height: 80px;
  }

  ${MediaQueries.amedium} {
    font-size: 96px;
    line-height: 96px;
  }
`

export const TitleH1 = styled.h1`
  color: #fdf4f5;
  text-align: center;
  font-family: 'Source Sans 3';
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 1.2px;
`

export const Description = styled.p`
  color: #fdf4f5;
  text-align: center;
  font-family: 'Source Sans 3';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  ${MediaQueries.medium} {
    font-size: 20px;
    line-height: 28px;
  }

  ${MediaQueries.amedium} {
    font-size: 24px;
    line-height: 32px;
  }
`

export const HighlightIndicator = styled.img<{ variant: string }>`
  position: absolute;

  ${({ variant }) =>
    variant === 'database' &&
    css`
      left: -2px;
      top: -9px;
      width: 186px;
      transform: rotate(-3deg);
    `}

  ${({ variant }) =>
    variant === 'handCoins' &&
    css`
      left: -8px;
      top: -15px;
      width: 186px;
      transform: rotate(179deg);
    `}
`

export const HerobannerItemContainer = styled.div`
  position: relative;

  display: flex;
  width: 178px;
  padding: 16px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.04);
  box-shadow: -2px 21px 80px 0px rgba(63, 8, 8, 0.4);
  backdrop-filter: blur(28px);
`

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`

export const Label = styled.p`
  color: #fff;
  font-family: 'Source Sans 3';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
